import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includedInEveryVolume } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function IncludedSection() {
  return <section className="w-full bg-cream-100 px-6 py-20 sm:py-24" aria-labelledby="incluye-titulo" data-id="element-88" data-mp="37fnzy3yifv6x">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-20" data-id="element-89" data-mp="3cdpk6s7oa0jz">
        <div id="incluye-titulo" data-id="element-90" data-mp="3zgxu1vqu609">
          <SectionHeading align="left" title="Todos los Volúmenes Incluyen" data-id="element-91" data-mp="3z7fn0gxx354" />
        </div>

        <ul className="grid gap-5" data-id="element-92" data-mp="7z7vmpjotmea">
          {includedInEveryVolume.map(({
          title,
          description
        }) => <li key={title} className="flex items-start gap-4 border-b border-cream-300/70 pb-5 last:border-0 last:pb-0" data-id="element-93" data-mp="3qdqlu9vrhc0i">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-forest-600" data-id="element-94" data-mp="mxa1j6e6yjyp">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" strokeWidth={3} data-id="element-95" data-mp="roiay2fiu5bv" />
              </span>
              <p className="text-base leading-relaxed text-forest-700/80" data-id="element-96" data-mp="3qi5pheten0wn">
                <span className="font-semibold text-forest-800" data-id="element-97" data-mp="3mfskwtqe991g">{title}</span> — {description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}